import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { BehaviorSubject, combineLatest } from 'rxjs';

import type { LengthCounterServiceI } from '@core/prosemirror-legacy';

import type { LengthCounterState } from './length-counter.types';

@Injectable()
export class LengthCounterService implements LengthCounterServiceI {
  public state: Observable<LengthCounterState>;

  private _isEnabled = new BehaviorSubject<boolean>(false);
  private _value = new BehaviorSubject<number>(0);
  private _limit = new BehaviorSubject<number>(200);

  constructor() {
    this.state = combineLatest({
      isEnabled: this._isEnabled,
      limit: this._limit,
      value: this._value,
    });
  }

  public setIsEnabled(value: boolean) {
    this._isEnabled.next(value);
  }

  public setValue(value: number) {
    this._value.next(value);
  }

  public setLimit(value: number) {
    this._limit.next(value);
  }
}
